import { useForm } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'
import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'
import Input from '@arianna/design-system/Input'
import Button from '@arianna/design-system/Button'

interface Props {
  errors: Record<string, string>
  flash: Record<string, string>
}

export default function ForgotPassword({ errors, flash }: Props) {
  const form = useForm({ email: '' })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/users/password', { forceFormData: false })
  }

  return (
    <AuthLayout>
      <Heading variant="h3" style={{ marginBottom: 'var(--space-1)' }}>
        Recupera password
      </Heading>
      <Text
        variant="body"
        style={{ color: 'var(--ink-3)', display: 'block', marginBottom: 'var(--space-6)' }}
      >
        Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.
      </Text>

      {flash.notice && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--accent) 10%, transparent)',
            border: '1px solid var(--accent)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <Text variant="meta" style={{ color: 'var(--accent)', fontSize: 13 }}>
            {flash.notice}
          </Text>
        </div>
      )}

      {(errors.email || form.errors.email) && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--red) 10%, transparent)',
            border: '1px solid var(--red)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <Text variant="meta" style={{ color: 'var(--red)', fontSize: 13 }}>
            {errors.email ?? form.errors.email}
          </Text>
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
      >
        <Input
          label="Email"
          type="email"
          autoComplete="email"
          value={form.data.email}
          onChange={(e) => form.setData('email', e.target.value)}
          required
        />
        <Button
          type="submit"
          variant="primary"
          size="md"
          disabled={form.processing}
          style={{ width: '100%' }}
        >
          {form.processing ? 'Invio in corso…' : 'Invia istruzioni'}
        </Button>
      </form>

      <div
        style={{
          marginTop: 'var(--space-6)',
          paddingTop: 'var(--space-4)',
          borderTop: '1px solid var(--line)',
          textAlign: 'center',
        }}
      >
        <Text variant="meta" style={{ color: 'var(--ink-3)', fontSize: 13 }}>
          <a href="/users/sign_in" style={{ color: 'var(--ink-3)', textDecoration: 'underline' }}>
            ← Torna al login
          </a>
        </Text>
      </div>
    </AuthLayout>
  )
}
